import { render, staticRenderFns } from "./zhongxinGH.vue?vue&type=template&id=2eb4473b&scoped=true"
import script from "./zhongxinGH.vue?vue&type=script&lang=js"
export * from "./zhongxinGH.vue?vue&type=script&lang=js"
import style0 from "./zhongxinGH.vue?vue&type=style&index=0&id=2eb4473b&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb4473b",
  null
  
)

export default component.exports